import { Button, FlexRow, PixelPlaceholderLoader } from "@similarweb/ui-components";

import { useStorage } from "app/custom-hooks/storage/useStorage";
import { translate } from "app/filters/i18nFilter";
import { DomainLimitUpgradeBanner } from "app/pages/sales-intelligence/common-components/feature-upgrade/components/DomainLimitUpgradeBanner/DomainLimitUpgradeBanner";
import { downloadFile } from "app/pages/sales-intelligence/modules/enrichment/utils/utils";
import managementTrackingService from "app/pages/sales-intelligence/modules/management/services/tracking/managementTrackingService";
import { resolveSignalsApiCustomAttributes } from "app/pages/sales-intelligence/modules/management/services/tracking/utils";
import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import { MAX_DOMAINS_LIMIT } from "app/pages/sales-intelligence/modules/management/sub-modules/subscribe-domains/containers/SubscribeDomainsContent/constants";
import { useSubscribeDomainsFileUrlQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/subscribe-domains/query/queries/useSubscribeDomainsFileUrlQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { formatNumberWithCommas } from "app/pages/sales-intelligence/utils/numbers";

import {
    StyledDomainLimitUpgradeBannerWrapper,
    StyledDomainsLimitsBlock,
    StyledDomainsLoaderWrapper,
    StyledFileLoaderWrapper,
    StyledLastUpdatedBlock,
    StyledSubscribeDomainsContent,
    StyledSubscribeFileBlock,
    StyledSubscribeFileBlockWrapper,
} from "./styles";

export const SubscribeDomainsContent = () => {
    const signalApiDomains = salesSettingsHelper.getSalesApiSignalsDomainsLimit() || 0;

    const { data } = useSignalsApiStatusPollingQuery();
    const { data: domainsListFileData } = useSubscribeDomainsFileUrlQuery();

    const [domainsLimitHookSubmitted, setDomainsLimitHookSubmitted] = useStorage<boolean>({
        item: {
            key: "domains-limit-hook-submitted",
            initialValue: false,
        },
        storage: window.sessionStorage,
    });

    const handleDownloadFile = (url?: string) => {
        if (url) {
            managementTrackingService.trackSignalApiClickEvent(`get file`, resolveSignalsApiCustomAttributes(data));
            downloadFile("file.csv", url);
        }
    };

    return (
        <StyledSubscribeDomainsContent>
            {data?.subscribedDomainsCount &&
            signalApiDomains <= data?.subscribedDomainsCount &&
            signalApiDomains < MAX_DOMAINS_LIMIT ? (
                <StyledDomainLimitUpgradeBannerWrapper>
                    <DomainLimitUpgradeBanner
                        isSubmitted={domainsLimitHookSubmitted}
                        onSubmit={() => {
                            managementTrackingService.trackSignalApiClickEvent(
                                `signals API domains/upgrade`,
                                resolveSignalsApiCustomAttributes(data),
                            );
                            setDomainsLimitHookSubmitted(true);
                        }}
                    />
                </StyledDomainLimitUpgradeBannerWrapper>
            ) : null}

            <StyledSubscribeFileBlockWrapper>
                <StyledSubscribeFileBlock>
                    <FlexRow>
                        {data?.domainsUpdateDate ? (
                            <StyledLastUpdatedBlock>
                                {translate("si.management.integration.subscribe-domains.last-date", {
                                    date: new Date(data.domainsUpdateDate).toLocaleDateString(),
                                })}
                            </StyledLastUpdatedBlock>
                        ) : null}
                        {data?.isDomainsFileProcessing ? (
                            <StyledFileLoaderWrapper>
                                <PixelPlaceholderLoader
                                    width={82}
                                    height={36}
                                />
                            </StyledFileLoaderWrapper>
                        ) : (
                            <Button
                                type="flat"
                                onClick={() => handleDownloadFile(domainsListFileData?.url)}
                            >
                                {translate("si.management.integration.subscribe-domains.get-file")}
                            </Button>
                        )}
                    </FlexRow>
                </StyledSubscribeFileBlock>
                {data?.isDomainsFileProcessing ? (
                    <StyledDomainsLoaderWrapper>
                        <PixelPlaceholderLoader
                            width={111}
                            height={14}
                        />
                    </StyledDomainsLoaderWrapper>
                ) : (
                    <StyledDomainsLimitsBlock>
                        {translate("si.management.integration.subscribe-domains.domains-limit", {
                            signalApiDomainsLimit: formatNumberWithCommas(signalApiDomains),
                            subscribeDomains: data?.subscribedDomainsCount,
                        })}
                    </StyledDomainsLimitsBlock>
                )}
            </StyledSubscribeFileBlockWrapper>
        </StyledSubscribeDomainsContent>
    );
};
